import React from "react"
import Layout from "../components/layout"
import IconFacebook from "../images/icon-facebook.png"
import IconInstagram from "../images/icon-instagram.png"
import IconLinkedIn from "../images/icon-linkedin.png"
import IconX from "../images/icon-x.png"
import NewsHeaderImage from "../images/news/header.png"
import { Helmet } from "react-helmet"
import Footer from "../components/footer"

export default function Template(data) {
  const {
    slug,
    first_name,
    bio,
    email,
    facebook_url,
    instagram_url,
    last_name,
    linkedin_url,
    pinterest_url,
    profile_image,
    title,
    twitter_handle,
  } = data.pageContext.author

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`MyRadar | ${first_name} ${last_name}`}</title>
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
      </Helmet>
      <Layout>
        <div className="post">
          <div className="modules">
            <div className="row">
              <div className="column">
                <img src={NewsHeaderImage} alt="" />
              </div>
            </div>
          </div>
          <div className="content">
            <div className="inside">
              <h3 class="title">
                MyRadar
                <br />
                News
                <br />—
              </h3>
              <div className="sep"></div>
              <div className="row">
                <div class="column">
                  <h1>
                    {first_name} {last_name}
                  </h1>
                  <h2>{title}</h2>
                  <div className="authors-social">
                  <img class="author-image" src={profile_image} />
                  </div>  
                  <div className="authors-social">
                    {facebook_url && (
                      <a href={facebook_url} className="logo logo--social">
                        <img src={IconFacebook} alt="Facebook logo" />
                      </a>
                    )}
                    {linkedin_url && (
                      <a href={linkedin_url} className="logo logo--social">
                        <img src={IconLinkedIn} alt="Linkedin logo" />
                      </a>
                    )}
                    {twitter_handle && (
                      <a
                        href={"https://x.com/" + twitter_handle}
                        className="logo logo--social"
                      >
                        <img src={IconX} alt="X logo" />
                      </a>
                    )}
                    {instagram_url && (
                      <a href={instagram_url} className="logo logo--social">
                        <img src={IconInstagram} alt="Instagram logo" />
                      </a>
                    )}
                  </div>

                  <h4></h4>
                  <div dangerouslySetInnerHTML={{ __html: bio.replace("\r\n","<br/><br/>") }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <Footer />
    </React.Fragment>
  )
}
